import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import Search from '../../Components/Search'
import featuresData from '../../JsonData/featuresData.json';
import Gallery from '../../Components/Gallery';
import Review from '../../Components/Review';
import ContactForm from '../../Components/ContactForm';
import { motion } from "framer-motion";
const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [location]);
  const slideInFromBottom = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.2 },
    transition: { duration: 0.8, ease: "easeOut" },
  };

  const achievements = [
    {
      value: "234K+",
      description: "Satisfied bookings signify trust and satisfaction",
    },
    {
      value: "500K",
      description: "Honoring outstanding community contributions",
    },
    { value: "40%", description: "Increasing visibility and reservations" },
    { value: "12M", description: "A growing community of happy users" },
  ];

  return (
    < main className="bg-[#FAFAFA]">
      <section className="relative flex justify-center items-center w-full lg:h-[981px] md:h-[656px] h-[852px] overflow-hidden">
        <img
          src="/images/Home/banner-compressed.webp"
          alt="imgBanner"
          className="w-full h-full object-cover "
        />
        <div className="absolute text-center w-[308px] h-auto top-[316px] px-[43] md:w-[554px] lg:w-[907px]">
          <h2 className="font-lora font-medium lg:text-[52px] lg:leading-[60px] md:text-[32px] md:leading-[38px] text-[28px] leading-[34px] text-[#F9F9F9]">
            Luxury Stays, Perfectly Curated
          </h2>
          <p className="font-outfit text-white lg:text-[18px] md:text-[16px] text-[14px] opacity-90 mt-4 md:mt-5 lg:mt-6">
            Experience premium homes with comfort, style, and world-class amenities.
          </p>
        </div>
        <div className="absolute lg:top-[604px] md:top-[446px] top-[532px]  px-4">
          <Search />
        </div>
      </section>





      <section className=" lg:mt-[200px] mt-[120px] flex flex-col justify-center items-center w-full lg:px-[106px] md:px-[64px] px-4 ]">
        <div className="mt-5 px-16 lg:px-80 md:px-4">
          <h1 className="text-center text-[18px] md:text-[24px] lg:text-[38px] font-lora font-medium">
            Experience the Pinnacle of Premium Service
          </h1>
        </div>

        <div className="lg:pt-[96px] md:pt-[65px] pt-[40px] grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-[18px] md:gap-[15px] lg:gap-[32px] mx-auto lg:w-[1300px] md:w-[736px]">
          {featuresData.map((feature, index) => (
            <motion.div
              key={index}

              className="bg-white shadow-lg  rounded-[15px]  border-[0.5px] flex flex-col lg:px-4 lg:w-[301px] lg:h-[260px] w-[172px] h-[156px] md:w-[165px] md:h-[156px] "
              initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true, amount: 0.2 }}
              whileHover={{ scale: 1.05, y: -5 }}
            >
              <div className="flex flex-col justify-start items-start w-[140px] h-[62px] md:w-[133px] md:h-[62px] lg:w-[195px] lg:h-[110px] mt-2 lg:mt-6 px-4 lg:px-4">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-[32px] h-[32px] lg:w-[56px] lg:h-[56px] object-cover rounded-md"
                />
                <h2 className="lg:mt-6  md:mt-3 mt-3 text-[14px] md:text-[18px] lg:text-[24px]  text-[#151515] font-lora whitespace-nowrap">
                  {feature.title}
                </h2>
              </div>

              <div className="lg:w-[237px] lg:h-[44px] md:w-[133px] md:h-[32px] w-[140px] h-[28px] lg:mt-2  md:mt-3   ">
                <p className="lg:px-4 px-4 py-3  outfit-label ">
                  {feature.description}
                </p>
              </div>
            </motion.div>

          ))}
        </div>
      </section>

      <section className="pt-[120px]  lg:pt-[200px] flex flex-col justify-center items-center w-full  lg:px-[106px] md:px-[64] px-4">
        {/* Desktop & Tablet View */}
        <motion.div className="hidden md:flex justify-center  ">
          <div className="lg:w-[1302px] lg:h-[603px] md:w-[706px] md:h-[578px]">
            <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-4 items-start">
              {/* Image Section */}
              <div className=" relative flex justify-start  ">
                <motion.div className="bg-customGreen  lg:w-[416px] lg:h-[490px]  md:w-[266px] md:h-[266px] rounded-[6px] relative " whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 1.02 }}
                  transition={{ type: "spring", stiffness: 200, damping: 10 }}>
                  <img
                    src="/images/Home/about.webp"
                    alt="About Us"
                    className="relative rounded-[12px] object-cover lg:ml-12 md:ml-8 mt-8  md:w-[249px] md:h-[283px] lg:w-[471px] lg:h-[533px]"

                  />
                </motion.div>
              </div>

              {/* About Section */}
              <motion.div
                className="relative shadow-transparent rounded-lg mt-10 lg:ml-[80px]  lg:w-[726px] md:w-[395px] "
                {...slideInFromBottom}
              >
                <h2 className="lg:text-[38px] md:text-[24px]  text-[18px] leading- [26px] font-medium font-lora">
                  About Us
                </h2>
                <p className="outfit-text  py-10 text-justify ">
                  Founded by a collective of passionate tech enthusiasts, Znorm
                  Homes began as a humble hobby and has since evolved into a
                  thriving venture dedicated to crafting delightful stays for
                  our guests. Driven by our commitment to excellence, we are
                  continuously expanding our services to embrace multiple
                  cities, implementing ongoing improvements to enhance the
                  overall guest experience. Our journey is fueled by a genuine
                  desire to create lasting memories and foster joy in every
                  stay.
                </p>
              </motion.div>


              {/* Floating Component */}
              <motion.div
                className=" absolute mt-10 lg:mt-[330px] md:mt-[360px] lg:ml-64 bg-white   rounded-[10px]  lg:w-[989px] md:w-[703px] "
                style={{ boxShadow: '0px 2px 16px 0px #0000000F' }}
                {...slideInFromBottom}
              >
                <div className="lg:p-12 lg:w-[886px] space-y-[32px]">
                  <h3 className="
  font-lora font-medium  text-[#151515]
  text-[14px] leading-[18px] tracking-[0px]         
  md:text-[18px] md:leading-[24px]                
  lg:text-[24px] lg:leading-[100%] lg:tracking-[0px]  
">
                    Where Comfort Meets Innovation
                  </h3>

                  <p className="outfit-text   ">
                    We blend the warmth of home with cutting-edge technology.
                    Our platform simplifies your search for the perfect stay,
                    prioritizing transparency and reliability, and a seamless
                    booking experience so you can focus on creating cherished
                    memories.
                  </p>
                  <p className="outfit-text mt-2 ">
                    Whether exploring a bustling city or seeking a tranquil
                    escape, Znorm is your trusted partner in finding
                    accommodations that feel like home.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>

        {/* Mobile View */}
        <div className="block md:hidden w-full ">
          <motion.div className="text-center" {...slideInFromBottom}>
            <h2 className="text-[18px] font-bold">About Us</h2>
            <p className="outfit-text p-2 mb-4">
              Founded by a collective of passionate tech enthusiasts, Znorm
              Homes began as a humble hobby and has since evolved into a
              thriving venture dedicated to crafting delightful stays for our
              guests. Driven by our commitment to excellence, we are
              continuously expanding our services to embrace multiple cities,
              implementing ongoing improvements to enhance the overall guest
              experience. Our journey is fueled by a genuine desire to create
              lasting memories and foster joy in every stay.
            </p>
          </motion.div>
          <div className="flex justify-center w-[316px] h-[272px]">
            <div className="bg-customGreen w-[280px] h-[217px] rounded-lg relative">
              <motion.img
                src="/images/Home/about.webp"
                alt="About Us"
                className="relative rounded-lg object-cover w-[280px] h-[230px] mt-4 ml-6"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 1.02 }}
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              />
            </div>
          </div>
          <motion.div
            className="mt-2 bg-white  px-4 w-full rounded-[12px]  shadow-lg border-[0.5]   h-[266px] "
            {...slideInFromBottom}
          >
            <h3 className="text-[14px] lora-title Py-6">
              Where Comfort Meets Innovation
            </h3>
            <p className="outfit-text mt-6">
              We blend the warmth of home with cutting-edge technology. Our
              platform simplifies your search for the perfect stay, prioritizing
              transparency and reliability, and a seamless booking experience so
              you can focus on creating cherished memories.
            </p>
            <p className="outfit-text mt-6 ">
              Whether exploring a bustling city or seeking a tranquil escape,
              Znorm is your trusted partner in finding accommodations that feel
              like home.
            </p>
          </motion.div>
        </div>

      </section>


      {/* Gallery component */}
      <section id="gallery" className="lg:mt-[200px] mt-[120px] md:mt-[64px] lg:px-[106px] md:px[64px] px-4">
        <Gallery />
      </section >

      <section className="flex flex-col justify-center items-center lg:px-[106px] w-full  pt-[120px] lg:pt-[200px] md:px[64px] px-4 ">

        <div className="lg:w-[1302px] md:w-[706px] ">
          <motion.div
            className="text-center lg:text-left md:text-left text-[#151515] lg:w-[704px] md:w-[448px] w-[352px] mb-[40px]"
            {...slideInFromBottom}
          >
            <div className="w-full flex justify-center lg:justify-start">
              <div className="flex items-center">
                <h2 className="font-lora font-medium lg:text-[24px] lg:leading-[22px] tracking-[0em]">Our Achievements</h2>

                {/* SVG line next to "Our Achievements" */}
                <div className="ml-2">
                  {/* Mobile view (default) */}
                  <svg
                    className="block md:hidden mt-2"
                    width="32"
                    height="1"
                    viewBox="0 0 32 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line y1="0.5" x2="32" y2="0.5" stroke="black" strokeWidth="0.5" />
                  </svg>

                  {/* Tablet view */}
                  <svg
                    className="hidden md:block lg:hidden mt-4"
                    width="64"
                    height="1"
                    viewBox="0 0 64 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line y1="0.5" x2="64" y2="0.5" stroke="black" strokeWidth="0.5" />
                  </svg>

                  {/* Desktop view */}
                  <svg
                    className="hidden lg:block mt-6"
                    width="64"
                    height="1"
                    viewBox="0 0 64 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line y1="0.5" x2="64" y2="0.5" stroke="black" strokeWidth="0.5" />
                  </svg>
                </div>
              </div>
            </div>

            <p className="md:text-[24px] lg:text-[38px] text-[18px] py-[24px] font-medium text-[#151515] font-lora">
              Hotel Booking Ensuring Comfortable
            </p>
          </motion.div>
          <div className="flex flex-wrap md:flex-nowrap lg:flex-nowrap gap-8 md:gap-4 lg:gap-10   ">
            <div className="grid grid-cols-2 gap-y-[40px] gap-x-4 md:gap-y-[30px] md:gap-x-16 lg:gap-x-[40px] lg:pt-24  md:p-4">
              {achievements.map((achievement, index) => (
                <motion.div
                  key={index}
                  className="bg-[#F0F2EA] shadow-md rounded-[18px] lg:w-[336px] lg:h-[256px] md:w-[190px] md:h-[220px] w-[173px] h-[164px] text-center transition-all duration-300 hover:bg-black hover:text-white px-[32px]"
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 1.02 }}
                  transition={{ type: "spring", stiffness: 200, damping: 10 }}
                >

                  <h3 className="outfit-display  lg:mt-[72px] md:mt-[50px] mt-8 transition-all duration-300">
                    {achievement.value}
                  </h3>
                  <p className=" mt-2 outfit-text transition-all duration-300 hover:text-white  ">
                    {achievement.description}
                  </p>
                </motion.div>

              ))}
            </div>
            <div className="flex flex-col items-center md:items-start lg:items-start lg:w-[558px] lg:h-[663px] md:w-[400px] md:h-[430px] w-[362px] h-[276px]  md:p-8">
              <motion.img
                src="/images/Home/image3.webp"
                alt="Achievements"
                className="rounded-lg shadow-lg mb-4 w-full lg:h-[525px] md:h-[400px] object-cover"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
              />
              <div className="w-full lg:h-[44px]">
                <p className="text-[#6A6A6A] text-center lg:text-left mb-4 font-outfit font-[400] lg:text-[16px] lg:leading-[22px] tracking-[0em]">
                  Our journey has been fueled by a commitment to excellence and
                  a focus on building meaningful connections with our community.
                </p>
                <a href="#" className="font-outfit lg:text-[16px] md:text-[14px] text-[12px] underline block text-right text-[#93B175] ">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>




      {/* Review componnet*/}

      <Review />


      {/* Contact section */}

      <section className="flex flex-col justify-items items-center mt-[160px] md:mt-[176px] lg:mt-[256px] w-full  lg:px-[105px] md:px-[64px] px-4 ">
        <div className="relative mt-20 mb-20 w-full max-w-[1300px] h-auto rounded-[31px]">
          <div className="absolute inset-0">
            <img
              src="/images/Home/form.webp"
              alt="Background"
              className="w-full h-full object-cover  rounded-[31px]"
            />
          </div>
          <div className="relative flex flex-col lg:flex-row md:flex-row items-start justify-between p-6 lg:px-10 gap-8">
            {/* Left Section: Text */}
            <div className="text-white lg:text-left text-center w-full lg:w-[518px] md:w-[274px] lg:mt-[50px] space-y-6">
              <h2 className="font-lora font-medium  lg:text-[38px] lg:leading-[100%] text-[18px] leading-[26px] ">
                Stay Connected With Us
                <br />
                for Assistance and Updates
              </h2>
              <p className="font-outfit text-[12px] lg:leading-[20px] lg:text-[16px] leading-[22px] opacity-90">
                We're here to assist you! Whether you have questions, need
                support, or want to share your feedback, simply fill out the
                form below. Our team will get back to you promptly. Let's stay
                connected and make your experience with Znorm Homes even better!
              </p>
            </div>

            {/* Right Section: Contact Form */}
            <div className="bg-white rounded-[12px] lg:rounded-[16px] shadow-lg w-full lg:w-[626px] md:w-[340px] p-4 lg:p-8">
              <h3 className="font-lora font-medium text-[24px] leading-[32px] tracking-[0.5%] text-center mb-4 lg:mt-4">
                Keep in touch
              </h3>
              <p className="font-outfit font-[350] text-[16px] leading-[24px] tracking-[0px] text-[#707070] text-center mb-6">
                Fill out the form, and we will get back to you soon. Let's stay
                connected!
              </p>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
